import { TranslocoService } from '@ngneat/transloco';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'optional',
})
export class OptionalLabelPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: string): string {
    const optionalText = this.translocoService.translate('Optional'); // Translate the term "Optional"
    return `${value} <span class="text-secondary">(${optionalText})</span>`;
  }
}
